import React from 'react';
import { Box } from '@mui/material';
import { Theme } from '@mui/material/styles';
import classNames from 'classnames';
import makeStyles from '@mui/styles/makeStyles';
import { getAspectRatioHeight } from '../lib/Media';

const useStyles = makeStyles((theme: Theme) => ({
  border: {
    border: '1px solid var(--border-gray-light)',
  },
  box: {
    overflow: 'hidden',
    position: 'relative',
    width: '100%',
  },
  rounded: {
    borderRadius: theme.spacing(1),
  },
}));

export interface ContentTileProps {
  border?: boolean;
  children: React.ReactNode;
  rounded?: boolean;
  width?: number | null;
}

const ContentTile: React.FC<ContentTileProps> = (props: ContentTileProps) => {
  const classes = useStyles();

  const { border = false, children, rounded = true, width } = props;

  return (
    <Box
      className={classNames(classes.box, {
        [classes.border]: border,
        [classes.rounded]: rounded,
      })}
      sx={(theme) => ({
        height: width ? getAspectRatioHeight(width) : theme.spacing(44),
      })}
    >
      {children}
    </Box>
  );
};

export default ContentTile;
